module.exports = __webpack_public_path__ + "static/media/ic_slack.4858e020.svg";